import { Component, OnInit } from '@angular/core';
import { AnimationOptions, BMCompleteLoopEvent } from 'ngx-lottie';
import { SplashScreenStateService } from '../../services/splash/splash-screen-state.service';

@Component({
    selector: 'app-splash',
    templateUrl: './splash.component.html',
    styleUrls: ['./splash.component.scss']
})

export class SplashComponent implements OnInit {

    public showSplash = false;

    public options: AnimationOptions = {
        path: '/XpressApp/assets/animation/lf20_DVSwGQ.json',
        autoplay: true,
        loop: true,
    };

    public styles: Partial<CSSStyleDeclaration> = {
        position: 'absolute',
        top: '344px',
        left: '505px',
        width: '830px',
        height: '437px',
        zIndex: '100000000',
    };

    constructor(private splashScreenStateService: SplashScreenStateService) { }

    ngOnInit(): void {
        this.splashScreenStateService.subscribe((res: any) => {
            this.switchSplashAnimation(res);
        });
    }

    private switchSplashAnimation(show: boolean) {
        setTimeout(() => {
            this.showSplash = show;
        }, 250);
    }
}
